
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("86upE", function(module, exports) {
/* ContentByLabelMacroRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $6T2gk = parcelRequire("6T2gk");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");

const $8c10b7ed0d23895f$export$f238d9824f6c55bf = (macroParamsForQuery)=>{
    const { cql: cql } = macroParamsForQuery;
    const shouldSkipQuery = !cql?.trim();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $6T2gk.default), {
        variables: {
            ...macroParamsForQuery,
            skipSearchTitle: (0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title'),
            skipContentTitle: !(0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title')
        },
        skip: shouldSkipQuery,
        fetchPolicy: 'cache-first',
        __callerPackage__: "content-by-label-macro"
    });
    return {
        data: data,
        error: error ?? null,
        loading: Boolean(loading)
    };
};



var $lTGWQ = parcelRequire("lTGWQ");




var $d129bc68587a4873$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["Page"] = "page";
    ContentType["Blogpost"] = "blogpost";
    ContentType["LivePage"] = "live-page";
    ContentType["Whiteboard"] = "whiteboard";
    ContentType["Database"] = "database";
    ContentType["Embed"] = "embed";
    ContentType["Folder"] = "folder";
    ContentType["Slide"] = "slide";
    return ContentType;
}({});


function $3ee95ce1d66ab67e$export$b441af81100aa49a(type, subType) {
    if (type === 'blogpost') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Blogpost;
    if (type === 'liveDoc' || type === 'page' && subType === 'live') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).LivePage;
    if (type === 'whiteboard') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Whiteboard;
    if (type === 'database') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Database;
    if (type === 'embed') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Embed;
    if (type === 'folder') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Folder;
    if (type === 'slide') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Slide;
    return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Page;
}
function $3ee95ce1d66ab67e$var$extractLabels(content) {
    const labels = [];
    const rawLabels = content?.labels?.nodes;
    if (rawLabels) {
        for (const label of rawLabels)if (label != null) labels.push({
            name: label.name ?? ''
        });
    }
    return labels;
}
function $3ee95ce1d66ab67e$export$11c8697609bb0569(data) {
    if (!data?.search?.nodes) return undefined;
    const items = [];
    for (const node of data.search.nodes){
        if (node == null) continue;
        items.push({
            id: node.content?.id ?? '',
            title: (0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title') ? node.content?.title ?? '' : node.title ?? '',
            type: $3ee95ce1d66ab67e$export$b441af81100aa49a(node.content?.type, node.content?.subType),
            url: node.url ? `/wiki${node.url}` : '',
            space: {
                id: node.content?.space?.id ?? '',
                key: node.content?.space?.key ?? '',
                name: node.content?.space?.name ?? ''
            },
            excerpt: node.content?.macroExcerpt?.atlasDocFormat ?? '',
            mediaToken: node.content?.body?.atlas_doc_format?.mediaToken?.token ?? '',
            labels: $3ee95ce1d66ab67e$var$extractLabels(node.content)
        });
    }
    return {
        items: items
    };
}





const $af06f72efa10cc57$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    emptyTitle: {
        id: "content-by-label-macro.emptyTitle",
        defaultMessage: "Filter by label"
    },
    emptyContent: {
        id: "content-by-label-macro.emptyContent",
        defaultMessage: "There are no items with the selected labels at this time."
    },
    emptyContentInEditor: {
        id: "content-by-label-macro.emptyContentInEditor",
        defaultMessage: "There are no items with the selected labels at this time. Click the edit icon to configure labels."
    },
    error: {
        id: "content-by-label-macro.error",
        defaultMessage: "An error occurred while loading content by label."
    },
    loading: {
        id: "content-by-label-macro.loading",
        defaultMessage: "Retrieving content\u2026"
    },
    errorLabelsRequired: {
        id: "content-by-label-macro.errorLabelsRequired",
        defaultMessage: "'labels' parameter is required."
    },
    errorParseMax: {
        id: "content-by-label-macro.errorParseMax",
        defaultMessage: "Error parsing 'maxResults' parameter."
    },
    errorSearch: {
        id: "content-by-label-macro.errorSearch",
        defaultMessage: "Error running search."
    },
    errorInvalidInput: {
        id: "content-by-label-macro.errorInvalidInput",
        defaultMessage: "Invalid input."
    },
    excerptSeparator: {
        id: "content-by-label-macro.excerptSeparator",
        defaultMessage: "\u2014"
    },
    spaceLabel: {
        id: "content-by-label-macro.spaceLabel",
        defaultMessage: "({spaceName})"
    }
});


/* ContentEntry.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $lBKFk = parcelRequire("lBKFk");


var $2hJf7 = parcelRequire("2hJf7");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $cSGyR = parcelRequire("cSGyR");


var $bDjVc = parcelRequire("bDjVc");


var $kWSTb = parcelRequire("kWSTb");


var $kLlYX = parcelRequire("kLlYX");


var $7vK9E = parcelRequire("7vK9E");





var $1l0kj = parcelRequire("1l0kj");



/* ContentExcerpt.tsx generated by @compiled/babel-plugin v3.0.2 */ 








const $cca4a13a0573e764$var$styles = {
    excerptOuter: "_1UtDYzZpcK _39xV02DC6J _4bt5LAIZbP",
    excerptInner: "_4rYULUAkOf"
};
const $cca4a13a0573e764$var$parseAdfDocument = (adf)=>{
    if (!adf) return null;
    try {
        return JSON.parse(adf);
    } catch  {
        return null;
    }
};
const $cca4a13a0573e764$export$c719936edb709f23 = (excerptType, excerpt)=>{
    if (excerptType === (0, $lTGWQ.ExcerptType).None) return false;
    const adfDocument = $cca4a13a0573e764$var$parseAdfDocument(excerpt);
    if (adfDocument && adfDocument.content && adfDocument.content.length > 0 && adfDocument.content.some((node)=>'content' in node && Array.isArray(node.content) && node.content.length > 0)) return adfDocument;
    return false;
};
const $cca4a13a0573e764$export$effe901625ca8e92 = function ContentExcerpt({ adfDocument: adfDocument, excerptType: excerptType, mediaToken: mediaToken, contentId: contentId, spaceKey: spaceKey, spaceId: spaceId, RendererWrapper: RendererWrapper }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cca4a13a0573e764$var$styles.excerptOuter,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cca4a13a0573e764$var$styles.excerptInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RendererWrapper, {
        adf: adfDocument.content,
        mediaToken: mediaToken,
        targetContentId: contentId,
        targetSpaceKey: excerptType === (0, $lTGWQ.ExcerptType).RichContent ? spaceKey : '',
        targetSpaceId: excerptType === (0, $lTGWQ.ExcerptType).RichContent ? spaceId ?? undefined : undefined
    })));
};


/* LabelList.tsx generated by @compiled/babel-plugin v3.0.2 */ 











const $d19b297071101ee6$var$styles = {
    labelChip: "_0bjKvDKxmn _2sNsIg7NXe _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4c065UFQfX _2Y7lL41Y8M _0KLXruDMqu",
    labelLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $d19b297071101ee6$export$835fcf23ab7bf88 = function LabelList({ labels: labels, spaceKey: spaceKey, limitLabelLinksToSpace: limitLabelLinksToSpace }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        shouldWrap: true,
        testId: "content-by-label-labels"
    }, labels.map((label)=>{
        const labelUrl = limitLabelLinksToSpace && spaceKey ? `/wiki/label/${spaceKey}/${label.name}` : `/wiki/label/${label.name}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            key: label.name,
            href: labelUrl,
            testId: `label-${label.name}`,
            xcss: $d19b297071101ee6$var$styles.labelLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d19b297071101ee6$var$styles.labelChip
        }, label.name));
    }));
};


const $bfbce6defdac332d$var$styles = {
    listItem: "_43nrzT2ADO",
    listItemFirst: "_43nrzTPgdg",
    details: "_0LQT5ENHnM",
    spaceInfo: "_1UtDYzKGUX",
    contentTypeIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    titleLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $bfbce6defdac332d$export$af895a2490aecfd5 = function ContentEntry({ item: item, showLabels: showLabels, showSpace: showSpace, excerptType: excerptType, limitLabelLinksToSpace: limitLabelLinksToSpace, isFirst: isFirst, RendererWrapper: RendererWrapper }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const excerptDocument = (0, $cca4a13a0573e764$export$c719936edb709f23)(excerptType, item.excerpt);
    const getContentTypeIcon = ()=>{
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Blogpost) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
            label: ""
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).LivePage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))), {
            label: ""
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Whiteboard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), {
            label: "",
            testId: "content-type-glyph-whiteboard"
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Database) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))), {
            label: "",
            testId: "content-type-glyph-database"
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Embed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))), {
            label: "",
            testId: "content-type-glyph-embed"
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Folder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
            label: "",
            testId: "content-type-glyph-folder"
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Slide) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))), {
            label: "",
            testId: "content-type-glyph-slide"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            label: ""
        });
    };
    const contentTypeIcon = getContentTypeIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: isFirst ? $bfbce6defdac332d$var$styles.listItemFirst : $bfbce6defdac332d$var$styles.listItem,
        testId: `content-entry-${item.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        testId: "content-by-label-inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bfbce6defdac332d$var$styles.contentTypeIcon,
        testId: `content-type-icon-${item.type}`
    }, contentTypeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: item.url,
        xcss: $bfbce6defdac332d$var$styles.titleLink
    }, item.title), showSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $bfbce6defdac332d$var$styles.spaceInfo
    }, formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).spaceLabel, {
        spaceName: item.space.name
    })), excerptDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $bfbce6defdac332d$var$styles.spaceInfo
    }, formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).excerptSeparator))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bfbce6defdac332d$var$styles.details
    }, excerptDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cca4a13a0573e764$export$effe901625ca8e92), {
        adfDocument: excerptDocument,
        mediaToken: item.mediaToken,
        excerptType: excerptType,
        contentId: item.id,
        spaceKey: item.space.key,
        spaceId: item.space.id,
        RendererWrapper: RendererWrapper
    }), showLabels && item.labels.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d19b297071101ee6$export$835fcf23ab7bf88), {
        labels: item.labels,
        spaceKey: item.space.key,
        limitLabelLinksToSpace: limitLabelLinksToSpace
    }))));
};


/* EmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ 












const $629ac813f858bbca$var$styles = {
    container: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4c065U8HPE _2Y7lL48HPE _4kiQYAIZbP",
    heading: "_2sNsIgmnOE _1UtDYzKGUX _1kk5Tku7m9",
    message: "_1UtDYzKGUX"
};
const $629ac813f858bbca$export$fddf379e22a74b00 = ({ title: title, showEditCTA: showEditCTA })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $629ac813f858bbca$var$styles.container,
        testId: "content-by-label-empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $629ac813f858bbca$var$styles.heading,
        as: "h5"
    }, title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).emptyTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $629ac813f858bbca$var$styles.message,
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), showEditCTA ? (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).emptyContentInEditor : (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).emptyContent))));
};


/* LoadingState.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $lfoFx = parcelRequire("lfoFx");


const $cf8b8295edbb494d$var$styles = {
    container: "_4c065U8HPE _2Y7lL48HPE _4kiQYAIZbP"
};
const $cf8b8295edbb494d$export$62aa48085237e36f = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cf8b8295edbb494d$var$styles.container,
        testId: "content-by-label-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        label: formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).loading)
    })));
};


const $cd3bdf4cbbb70502$var$styles = {
    list: "_3SamIH2ADO _0LQT5EPgdg _0aNu0LYbGa",
    invalidInputErrorDetail: "_3zvHkHdC7N"
};
const $cd3bdf4cbbb70502$var$BAD_REQUEST_EXCEPTION_ERROR_MESSAGE = 'BadRequestException';
const $cd3bdf4cbbb70502$var$isBadRequestExceptionError = (error)=>error.message.includes($cd3bdf4cbbb70502$var$BAD_REQUEST_EXCEPTION_ERROR_MESSAGE);
const $cd3bdf4cbbb70502$var$ContentByLabelMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams, RendererWrapper: RendererWrapper })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const { cql: cql, maxParseError: maxParseError, title: title, showLabels: showLabels, showSpace: showSpace, excerptType: excerptType, limitLabelLinksToSpace: limitLabelLinksToSpace, macroParamsForQuery: macroParamsForQuery } = (0, $lTGWQ.useParsedMacroParams)(macroParams, macroDefaultProps?.spaceKey, contentId);
    const { data: queryData, error: error, loading: loading } = (0, $8c10b7ed0d23895f$export$f238d9824f6c55bf)(macroParamsForQuery);
    const processedData = (0, $3ee95ce1d66ab67e$export$11c8697609bb0569)(queryData);
    const items = processedData?.items;
    if (!cql) {
        const labelsRequiredError = new Error(formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).errorLabelsRequired));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: labelsRequiredError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: labelsRequiredError
        }));
    }
    if (maxParseError) {
        const parseMaxError = new Error(formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).errorParseMax));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: parseMaxError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: parseMaxError
        }));
    }
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf8b8295edbb494d$export$62aa48085237e36f), null);
    if (error) {
        if ($cd3bdf4cbbb70502$var$isBadRequestExceptionError(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
                name: experienceName,
                contentId: contentId,
                extensionKey: extensionKey,
                mode: mode,
                attributes: attributes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
                title: formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).errorInvalidInput),
                appearance: "error"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "p",
                color: "color.text.subtle",
                xcss: $cd3bdf4cbbb70502$var$styles.invalidInputErrorDetail
            }, error.message)));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }));
    }
    if (!items || items.length === 0) {
        const isEditorPreview = macroDefaultProps?.mode === 'editor';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $629ac813f858bbca$export$fddf379e22a74b00), {
            title: title,
            showEditCTA: isEditorPreview
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "content-by-label-macro",
        "data-fabric-macro": macroDefaultProps?.attributes?.macroId,
        "data-macro-body": ""
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        as: "ul",
        xcss: $cd3bdf4cbbb70502$var$styles.list
    }, items.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bfbce6defdac332d$export$af895a2490aecfd5), {
            key: item.id,
            item: item,
            showLabels: showLabels,
            showSpace: showSpace,
            excerptType: excerptType,
            limitLabelLinksToSpace: limitLabelLinksToSpace,
            isFirst: index === 0,
            RendererWrapper: RendererWrapper
        })))));
};
const $cd3bdf4cbbb70502$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).error);
const $cd3bdf4cbbb70502$export$539897642bf8eef = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $cd3bdf4cbbb70502$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd3bdf4cbbb70502$var$ContentByLabelMacroRendererComponent, props));
};
module.exports["ContentByLabelMacroRenderer"] = $cd3bdf4cbbb70502$export$539897642bf8eef;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("6T2gk", function(module, exports) {
/**
 * @generated SignedSource<<4230a09192e7b8576253c6e3344b7ed0>>
 * @relayHash 3bc22a19b7e4388cf4e2ded6f764d99a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92e187353ccc998aef9dc268068502b21c671e33e8556549b51a338719a28ef5
const $fed9f45d550b7e93$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fallbackToBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeExcerpt"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "maxExcerptBlocks"
    }, v5 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "skipContentTitle"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "skipSearchTitle"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "condition": "skipSearchTitle",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": v7 /*: any*/ 
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastModified"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "condition": "skipContentTitle",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "condition": "includeExcerpt",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceMacroExcerptBody",
                                            "kind": "LinkedField",
                                            "name": "macroExcerpt",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "fallbackToBody",
                                                            "variableName": "fallbackToBody"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "maxBlocks",
                                                            "variableName": "maxExcerptBlocks"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "atlasDocFormat"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContentBodyPerRepresentation",
                                            "kind": "LinkedField",
                                            "name": "body",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentBody",
                                                    "kind": "LinkedField",
                                                    "name": "atlas_doc_format",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "EmbeddedMediaToken",
                                                            "kind": "LinkedField",
                                                            "name": "mediaToken",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "token"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentByLabelDataQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentByLabelDataQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "cacheID": "3bc22a19b7e4388cf4e2ded6f764d99a",
            "id": "92e187353ccc998aef9dc268068502b21c671e33e8556549b51a338719a28ef5",
            "metadata": {},
            "name": "useContentByLabelDataQuery",
            "operationKind": "query",
            "text": "query useContentByLabelDataQuery($cql:String!,$first:Int,$includeExcerpt:Boolean!,$fallbackToBody:Boolean!,$maxExcerptBlocks:Int,$skipSearchTitle:Boolean=false,$skipContentTitle:Boolean=true){search:confluence_search(cql:$cql,first:$first){nodes{title@skip(if:$skipSearchTitle),url,lastModified,content{id,title@skip(if:$skipContentTitle),type,subType,macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:$fallbackToBody,maxBlocks:$maxExcerptBlocks)}\n        body@include(if:$includeExcerpt){atlas_doc_format{mediaToken{token}}},space{id,key,name},labels{nodes{id,name}}}}}}"
        }
    };
}();
$fed9f45d550b7e93$var$node.hash = "1940c9c67b38d6b805a9e38cba96bfab";
var $fed9f45d550b7e93$export$2e2bcd8739ae039 = $fed9f45d550b7e93$var$node;
module.exports["default"] = $fed9f45d550b7e93$export$2e2bcd8739ae039;

});

parcelRegister("lTGWQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5fi0G = parcelRequire("5fi0G");

const $67a1e9c4dba455ef$var$MAX_RESULTS_CAP = 500;
const $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS = 15;
/**
 * Block caps applied to the `macroExcerpt.atlasDocFormat` field.
 *
 * "Excerpt preview" (simple) shows a short teaser, while "Page preview"
 * (rich content) shows a substantial portion of the page.
 */ const $67a1e9c4dba455ef$var$SIMPLE_EXCERPT_MAX_BLOCKS = 3;
const $67a1e9c4dba455ef$var$RICH_CONTENT_EXCERPT_MAX_BLOCKS = 50;
var $67a1e9c4dba455ef$export$b769d4fd9dd3feec = /*#__PURE__*/ function(ExcerptType) {
    ExcerptType["None"] = "none";
    ExcerptType["Simple"] = "simple";
    ExcerptType["RichContent"] = "rich content";
    return ExcerptType;
}({});
var $67a1e9c4dba455ef$export$9c8b9f8fac4b24ab = /*#__PURE__*/ function(SortOption) {
    SortOption["Creation"] = "created";
    SortOption["Title"] = "title";
    SortOption["Modified"] = "lastModified";
    return SortOption;
}({});
const $67a1e9c4dba455ef$var$SORT_PARAM_TO_CQL = {
    creation: "created",
    title: "title",
    modified: "lastModified"
};
function $67a1e9c4dba455ef$var$parseSortOption(value) {
    if (!value) return undefined;
    return $67a1e9c4dba455ef$var$SORT_PARAM_TO_CQL[value];
}
function $67a1e9c4dba455ef$var$parseBoolean(value, defaultValue) {
    if (value === undefined || value === '') return defaultValue;
    return value === 'true';
}
function $67a1e9c4dba455ef$var$parseMax(value, maxCheckbox) {
    if (maxCheckbox === 'true') return {
        max: $67a1e9c4dba455ef$var$MAX_RESULTS_CAP,
        maxParseError: false
    };
    if (value === undefined || value === '') return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: false
    };
    const parsed = parseInt(value, 10);
    if (isNaN(parsed)) return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: true
    };
    if (parsed <= 0) return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: false
    };
    return {
        max: Math.min(parsed, $67a1e9c4dba455ef$var$MAX_RESULTS_CAP),
        maxParseError: false
    };
}
/**
 * Maps legacy CQL sort field names to their correct equivalents.
 * Legacy macros may have stored invalid field names directly in the cql param
 * (e.g. 'creation' instead of 'created', 'modified' instead of 'lastModified').
 */ const $67a1e9c4dba455ef$var$LEGACY_CQL_SORT_FIELD_REMAP = {
    creation: "created",
    modified: "lastModified"
};
/**
 * Normalizes sort field names in an existing ORDER BY clause within a CQL string.
 * Remaps legacy field names (e.g. 'creation', 'modified') to valid CQL field names.
 */ function $67a1e9c4dba455ef$var$normalizeCqlSortFields(cql) {
    return cql.replace(/(\border\s+by\s+)(\w+)/gi, (_match, prefix, field)=>{
        const lower = field.toLowerCase();
        const remapped = $67a1e9c4dba455ef$var$LEGACY_CQL_SORT_FIELD_REMAP[lower];
        return `${prefix}${remapped !== undefined ? remapped : field}`;
    });
}
function $67a1e9c4dba455ef$var$buildOrderByClause(sort, reverse) {
    if (!sort) return '';
    const direction = reverse ? 'desc' : 'asc';
    return ` order by ${sort} ${direction}`;
}
function $67a1e9c4dba455ef$var$parseExcerptType(value) {
    if (value === "simple") return "simple";
    if (value === "rich content") return "rich content";
    return "none";
}
function $67a1e9c4dba455ef$export$8f0d03faf499ec50(macroParams, currentSpaceKey, currentContentId) {
    const rawCql = macroParams?.cql?.value ?? '';
    const sort = $67a1e9c4dba455ef$var$parseSortOption(macroParams?.sort?.value);
    const reverse = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.reverse?.value, false);
    const { max: max } = $67a1e9c4dba455ef$var$parseMax(macroParams?.max?.value ?? macroParams?.maxResults?.value, macroParams?.maxCheckbox?.value);
    const resolvedCql = $67a1e9c4dba455ef$var$normalizeCqlSortFields((0, $5fi0G.resolveQueryShorthands)(rawCql, {
        currentSpaceKey: currentSpaceKey,
        currentContentId: currentContentId
    }));
    const orderByClause = $67a1e9c4dba455ef$var$buildOrderByClause(sort, reverse);
    const cql = resolvedCql + orderByClause;
    const excerptType = $67a1e9c4dba455ef$var$parseExcerptType(macroParams?.excerptType?.value);
    return {
        cql: cql,
        first: max,
        includeExcerpt: excerptType === "simple" || excerptType === "rich content",
        fallbackToBody: excerptType === "rich content",
        maxExcerptBlocks: excerptType === "rich content" ? $67a1e9c4dba455ef$var$RICH_CONTENT_EXCERPT_MAX_BLOCKS : $67a1e9c4dba455ef$var$SIMPLE_EXCERPT_MAX_BLOCKS
    };
}
function $67a1e9c4dba455ef$export$2f9066b0466085e(macroParams, currentSpaceKey, currentContentId) {
    return (0, $cozmU.useMemo)(()=>{
        const sort = $67a1e9c4dba455ef$var$parseSortOption(macroParams?.sort?.value);
        const reverse = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.reverse?.value, false);
        const { max: max, maxParseError: maxParseError } = $67a1e9c4dba455ef$var$parseMax(macroParams?.max?.value ?? macroParams?.maxResults?.value, macroParams?.maxCheckbox?.value);
        const title = macroParams?.title?.value ?? '';
        const showLabels = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.showLabels?.value, true);
        const showSpace = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.showSpace?.value, true);
        const excerptType = $67a1e9c4dba455ef$var$parseExcerptType(macroParams?.excerptType?.value);
        const macroParamsForQuery = $67a1e9c4dba455ef$export$8f0d03faf499ec50(macroParams, currentSpaceKey, currentContentId);
        const cql = macroParamsForQuery.cql;
        const limitLabelLinksToSpace = cql.includes('space = ');
        return {
            cql: cql,
            sort: sort,
            reverse: reverse,
            max: max,
            maxParseError: maxParseError,
            title: title,
            showLabels: showLabels,
            showSpace: showSpace,
            excerptType: excerptType,
            limitLabelLinksToSpace: limitLabelLinksToSpace,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams,
        currentSpaceKey,
        currentContentId
    ]);
}
module.exports["ExcerptType"] = $67a1e9c4dba455ef$export$b769d4fd9dd3feec;
module.exports["composeMacroParamsForQuery"] = $67a1e9c4dba455ef$export$8f0d03faf499ec50;
module.exports["useParsedMacroParams"] = $67a1e9c4dba455ef$export$2f9066b0466085e;

});

parcelRegister("5fi0G", function(module, exports) {
// Matches both bare and quoted variants of the supported sentinels
// (`currentSpace()` / `currentContent()`), tolerating optional whitespace
// before and inside the parentheses (e.g. `currentSpace ( )`). Some macro
// authors / older clients persist `"currentSpace()"` as a string literal, so
// we accept both forms. The sentinel name is captured so the resolver can
// look up the corresponding substitution value.
const $bbef8c560cd45789$var$SHORTHAND_REGEX = /"?(currentSpace|currentContent)\s*\(\s*\)"?/g;
const $bbef8c560cd45789$export$61a94fb63540ef7c = (rawCql, { currentSpaceKey: currentSpaceKey, currentContentId: currentContentId })=>{
    if (!rawCql) return rawCql;
    return rawCql.replace($bbef8c560cd45789$var$SHORTHAND_REGEX, (match, sentinel)=>{
        switch(sentinel){
            case 'currentSpace':
                return currentSpaceKey == undefined ? match : `"${currentSpaceKey}"`;
            case 'currentContent':
                return currentContentId == undefined ? match : `"${currentContentId}"`;
            default:
                return match;
        }
    });
};
module.exports["resolveQueryShorthands"] = $bbef8c560cd45789$export$61a94fb63540ef7c;

});


//# sourceMappingURL=ContentByLabelMacroRenderer.6f553112.js.map
